import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { useGetIdentity } from "ra-core";
import { TransferInputs } from "./TransferInputs";

export const TransferCreate = () => {
  const { identity } = useGetIdentity();
  return (
    <Create mutationMode="pessimistic" redirect="list">
      <SimpleForm
        className="max-w-3xl"
        defaultValues={{
          sales_id: identity?.id,
          amount: 0,
          occurred_at: new Date().toISOString().slice(0, 10),
        }}
      >
        <TransferInputs />
      </SimpleForm>
    </Create>
  );
};
